export const padStart = (
  string: string,
  targetLength: number,
  padString = ' ',
) => {
  const paddedString = new Array(targetLength).join(padString);
  return (paddedString + string).slice(-targetLength);
};

export default padStart;
